import { AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import React, { useContext } from "react";
import { AvaliacaoProgramaContext } from "./AvaliacaoProgramaContext";

const OrcamentoFinanceiroPrograma = () => {
  const { dadosOrcamFinan, totalOrcamFinan } = useContext(AvaliacaoProgramaContext);

  function formatarValor(value) {
    let val = (value / 1).toFixed(2).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

  let headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Fonte" rowSpan={2} />
        <Column header="Dotação" colSpan={2} headerStyle={{ textAlign: "center" }} />
        <Column header="Créditos Adicionais" colSpan={2} />
        <Column header="Contingenciado / Bloqueado (C)" rowSpan={2} />
        <Column header="Empenhado (D)" rowSpan={2} />
        <Column header="Liquidado (E)" rowSpan={2} />
        <Column header="Empenhado (%)" colSpan={2} />
        <Column header="Liquidado (%)" colSpan={2} />
      </Row>
      <Row>
        <Column header="Inicial(A)" />
        <Column header="Atualizada(B)" />
        <Column header="Suplementar" />
        <Column header="Redução / Anulação" />

        <Column header="PPD(%) (D/A)" />
        <Column header="COFD (%) (D/(B-C))" />
        <Column header="Inicial (%) (E/A)" />
        <Column header="Atualizada (%) (E/B)" />
      </Row>
    </ColumnGroup>
  );

  let footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer={totalOrcamFinan.codgFonte} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrInicial)} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrAtualizado)} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrSuplementado)} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrAnulado)} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrContigenciadoBloqueado)} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrEmpenhado)} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrLiquidado)} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrPpd)} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrCofd)} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrLiquidadoInicial)} style={{ textAlign: "right" }} />
        <Column footer={formatarValor(totalOrcamFinan.vlrLiquidadoFinal)} style={{ textAlign: "right" }} />
      </Row>
    </ColumnGroup>
  );

  return (
    <DataTable
      value={dadosOrcamFinan}
      stripedRows
      showGridlines
      headerColumnGroup={headerGroup}
      footerColumnGroup={footerGroup}
      responsiveLayout="scroll"
    >
      <Column field="codgFonte" body={(e) => e.codgFonte} header="Fonte" style={{ textAlign: "right" }} />
      <Column
        field="vlrInicial"
        body={(e) => formatarValor(e.vlrInicial)}
        header="Inicial(A)"
        style={{ textAlign: "right" }}
      />
      <Column
        field="vlrAtualizado"
        body={(e) => formatarValor(e.vlrAtualizado)}
        header="Atualizada(B)"
        style={{ textAlign: "right" }}
      />
      <Column
        field="vlrSuplementado"
        body={(e) => formatarValor(e.vlrSuplementado)}
        header="Suplementar"
        style={{ textAlign: "right" }}
      />
      <Column
        field="vlrAnulado"
        body={(e) => formatarValor(e.vlrAnulado)}
        header="Redução / Anulação"
        style={{ textAlign: "right" }}
      />
      <Column
        field="vlrContigenciadoBloqueado"
        body={(e) => formatarValor(e.vlrContigenciadoBloqueado)}
        header="Contingenciado / Bloqueado (C)"
        style={{ textAlign: "right" }}
      />
      <Column
        field="vlrEmpenhado"
        body={(e) => formatarValor(e.vlrEmpenhado)}
        header="Empenhado (D)"
        style={{ textAlign: "right" }}
      />
      <Column
        field="vlrLiquidado"
        body={(e) => formatarValor(e.vlrLiquidado)}
        header="Liquidado (E)"
        style={{ textAlign: "right" }}
      />
      <Column
        field="vlrPpd"
        body={(e) => formatarValor(e.vlrPpd)}
        header="PPD(%) (D/A)"
        style={{ textAlign: "right" }}
      />
      <Column
        field="vlrCofd"
        body={(e) => formatarValor(e.vlrCofd)}
        header="COFD (%) (D/(B-C))"
        style={{ textAlign: "right" }}
      />
      <Column
        field="vlrLiquidadoInicial"
        body={(e) => formatarValor(e.vlrLiquidadoInicial)}
        header="Inicial (%) (E/A)"
        style={{ textAlign: "right" }}
      />
      <Column
        field="vlrLiquidadoFinal"
        body={(e) => formatarValor(e.vlrLiquidadoFinal)}
        header="Atualizada (%) (E/B)"
        style={{ textAlign: "right" }}
      />
    </DataTable>
  );
};

export default OrcamentoFinanceiroPrograma;
